import {Button, styled} from '@mui/material';

const StyledButton = styled(Button)`
	padding: 0;
	text-decoration: underline;
	font-size: 14px;
	align-self: flex-start;

	&:hover {
		text-decoration: underline;
	}
`;

export {StyledButton};
